import React from 'react';
import { useScrollAnimation } from './useScrollAnimation';

export const AnimatedSection = ({
  children,
  animation = 'fade-up',
  delay = 0,
  className = '',
  style = {},
}) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const getAnimationStyle = () => {
    const baseStyle = {
      transition: `all 0.6s cubic-bezier(0.4, 0, 0.2, 1) ${delay}ms`,
    };

    if (!isVisible) {
      switch (animation) {
        case 'fade-up':
          return {
            ...baseStyle,
            opacity: 0,
            transform: 'translateY(30px)',
          };
        case 'fade-in':
          return {
            ...baseStyle,
            opacity: 0,
          };
        case 'slide-left':
          return {
            ...baseStyle,
            opacity: 0,
            transform: 'translateX(30px)',
          };
        case 'slide-right':
          return {
            ...baseStyle,
            opacity: 0,
            transform: 'translateX(-30px)',
          };
        default:
          return baseStyle;
      }
    }

    return {
      ...baseStyle,
      opacity: 1,
      transform: 'translate(0, 0)',
    };
  };

  return (
    <div
      ref={ref}
      className={className}
      style={{
        ...getAnimationStyle(),
        ...style,
      }}
    >
      {children}
    </div>
  );
};
